export default (() => {

    function getClampedValue (value, min, max) {
        return Math.min(Math.max(value, min), max);
    }

    function getRandom (length = 5) {
        let randomNumber = Math.random();
        
        let getNumberIntegerDigitsLength = (number) => {
            return number.toString().split('.')[0].length;
        };

        if (isNaN(length)) {
            return wealthify.error.throwError('type.number.getRandom', 'value must be a number');
        }

        while (getNumberIntegerDigitsLength(randomNumber) < length) {
            randomNumber = randomNumber * 10;
        }

        return Math.floor(randomNumber);
    }

    function isPercent (value) {
        if (value === undefined) {
            return wealthify.error.throwError('type.number.isPercent', 'value must be defined');
        }

        return value >= 0 && value <= 100;
    }

    function isPositive (value) {
        if (value === undefined) {
            return wealthify.error.throwError('type.number.isPositive', 'value must be defined');
        }

        return value >= 0;
    }

    function isNegative (value) {
        if (value === undefined) {
            return wealthify.error.throwError('type.number.isNegative', 'value must be defined');
        }

        return value < 0;
    }

    function isNumber (value) {
        if (value === undefined) {
            return wealthify.error.throwError('type.number.isNumber', 'value must be defined');
        }

        value = _replaceThousandSeparators(value);

        if (typeof value === 'string') {
            const numberRegex = /^[-0-9.]*$/g;

            return value.match(numberRegex) !== null;
        }

        return typeof value === 'number';
    }

    function toCurrency (value, includeDecimal = true) {
        if (value  === undefined) {           
            return wealthify.error.throwError('type.number.toCurrency', 'value must be defined');
        }

        if (!isNumber(value)) {
            return wealthify.error.throwError('type.number.toCurrency', 'value must be of type number');
        }

        const groupsOf3NumbersRegex = /(\d)(?=(\d{3})+(?!\d))/g;
        const formattedValue =  includeDecimal ? Number.parseFloat(value).toFixed(2) : Number.parseInt(value);
        const thousandDelimitedValue = formattedValue.toString().replace(groupsOf3NumbersRegex, '$1,');

        return `£${thousandDelimitedValue}`;
    }

    function toNumber (value) {
        if (value  === undefined) {           
            return wealthify.error.throwError('type.number.toNumber', 'value must be defined');
        }

        value = _replaceThousandSeparators(value);

        if (!wealthify.type.number.isNumber(value)) {
            return null;
        }

        return Number.parseFloat(value);
    }

    function _replaceThousandSeparators (value) {
        return typeof value === 'string' && value.includes(',') ? value.replace(/,/g, '') : value;
    }

    function fromCurrency(value) {
        if (value === undefined) {
            return wealthify.error.throwError('type.number.fromCurrency', 'value must be defined');
        }
        
        value = _removeNonNumericalCharacters(value);

        return toNumber(value);
    }

    function _removeNonNumericalCharacters (value) {
        return typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;
    }

    return {
        getClampedValue,
        getRandom,
        isPercent,
        isPositive,
        isNegative,
        isNumber,
        toCurrency,
        toNumber,
        fromCurrency
    };

})();